/**
 * Fallback when /api/settings/billing fails.
 * Checkout URLs come only from REACT_APP_STRIPE_LINK_* env vars (no hardcoded links).
 */

function checkoutLink(envKey) {
  const fromEnv = process.env[envKey];
  return fromEnv || null;
}

export const FALLBACK_PLANS = [
  {
    id: 'audit',
    type: 'one_time',
    name: 'Account Health Audit',
    price_label: '$27',
    period: 'one-time',
    description: 'Full audit across behavioral signals with Enforcement Risk Score and downloadable PDF report.',
    features: [
      'Written report delivered instantly',
      'Enforcement Risk Score',
      'Specialist walkthrough',
      '$27 credit toward Monitor',
    ],
    checkout_url: checkoutLink('REACT_APP_STRIPE_LINK_AUDIT'),
    rank: 1,
  },
  {
    id: 'poa',
    type: 'one_time',
    name: 'Plan of Action',
    price_label: '$197',
    period: 'one-time',
    description: 'Customized POA from your account signals — for suspensions and policy appeals.',
    features: [
      'Root cause from account signals',
      'Corrective actions for reviewers',
      'Preventive measures for appeal',
      'POA templates in-product',
    ],
    checkout_url: checkoutLink('REACT_APP_STRIPE_LINK_POA'),
    rank: 2,
  },
  {
    id: 'monitor',
    type: 'subscription',
    name: 'Protego Monitor',
    price_label: '$297/mo',
    price_yearly_label: '$2,970/yr',
    period: 'monthly',
    description: 'Continuous monitoring, live Enforcement Risk Score, alerts, and full dashboard access.',
    features: [
      '30 behavioral signals · 6 KPI domains',
      'Live Enforcement Risk Score',
      'Unlimited specialist walkthroughs',
      'POA generation & audit PDF',
      '30-day money-back guarantee',
    ],
    checkout_url: checkoutLink('REACT_APP_STRIPE_LINK_MONITOR_MONTHLY'),
    checkout_url_yearly: checkoutLink('REACT_APP_STRIPE_LINK_MONITOR_YEARLY'),
    rank: 3,
    highlighted: true,
  },
  {
    id: 'guard',
    type: 'subscription',
    name: 'Protego Guard',
    price_label: '$697/mo',
    period: 'monthly',
    description: 'Maximum coverage for high-volume sellers — multi-account and priority support.',
    features: [
      'Everything in Protego Monitor',
      'Priority signal review',
      'Multi-account coverage',
      'Dedicated specialist channel',
    ],
    checkout_url: checkoutLink('REACT_APP_STRIPE_LINK_GUARD'),
    rank: 4,
  },
];
